
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ofNullable } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { ensureValidToken } from "../Auth.js";
import { handleFetchError } from "../ErrorHandling.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.0.0-rc.2/MapUtil.js";
import { singleton, empty, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { isEmpty, map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fetch$ } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { addPrefix } from "../CommunicationV2.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function createProcedureResultsPdf(procedureId, successMsg, errorMsg) {
    const id = procedureId.fields[0];
    return Cmd_OfPromise_either((tupledArg) => {
        const body_1 = tupledArg[2];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr;
            const tenant = ofNullable(localStorage.getItem("tenant"));
            return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
                const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                    let matchValue;
                    return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                        const matchValue_1 = tenant;
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            return singleton(["X-ONE-Tenant", matchValue_1]);
                        }
                    }))));
                })), 0)]);
                const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
                return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
            });
        }));
    }, [`/api/procedures/${id}/pdf`, `procedure-results-${id}.pdf`, undefined], successMsg, errorMsg);
}

export function createAssignmentProtocol(assignmentType, entityName, inventoryNumber, senderName, receiverName, storageName, comment, timestamp, returnDate, qrCodeIds, signatureUrl, imageUrl, entityImageUrl, senderImageUrls, receiverImageUrls, successMsg, errorMsg) {
    let entityImageUrl_1;
    const encodeImageUrls = (imageUrls) => join(",", map((str) => window.encodeURIComponent(str), imageUrls));
    const url = `/api/files/generate?assignmentType=${assignmentType}&entityName=${entityName}&inventoryNumber=${inventoryNumber}&senderName=${senderName}&receiverName=${receiverName}&comment=${comment}&timestamp=${timestamp}`;
    const url_1 = isEmpty(senderImageUrls) ? url : concat(url, "&senderImageUrls=", ...encodeImageUrls(senderImageUrls));
    const url_2 = isEmpty(receiverImageUrls) ? url_1 : concat(url_1, "&receiverImageUrls=", ...encodeImageUrls(receiverImageUrls));
    const url_3 = (storageName == null) ? url_2 : concat(url_2, "&storageName=", ...storageName);
    const url_4 = (returnDate == null) ? url_3 : concat(url_3, "&returnDate=", ...returnDate);
    const url_5 = (qrCodeIds == null) ? url_4 : concat(url_4, "&qrCodeIds=", ...qrCodeIds);
    let url_6;
    if (imageUrl == null) {
        url_6 = url_5;
    }
    else {
        const imageUrl_1 = imageUrl;
        url_6 = concat(url_5, "&imageUrl=", ...window.encodeURIComponent(imageUrl_1));
    }
    let url_7;
    if (signatureUrl == null) {
        url_7 = url_6;
    }
    else {
        const signatureUrl_1 = signatureUrl;
        url_7 = concat(url_6, "&signatureUrl=", ...window.encodeURIComponent(signatureUrl_1));
    }
    return Cmd_OfPromise_either((tupledArg) => {
        const body_1 = tupledArg[2];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let pr;
            const tenant = ofNullable(localStorage.getItem("tenant"));
            return ((pr = ensureValidToken(), pr.then(void 0, (handleFetchError)))).then((_arg) => {
                const headers = new Types_RequestProperties(1, [keyValueList(toList(delay(() => {
                    let matchValue;
                    return append((matchValue = _arg, (matchValue == null) ? (empty()) : singleton(new Types_HttpRequestHeaders(5, ["Bearer " + matchValue]))), delay(() => append(singleton(new Types_HttpRequestHeaders(11, ["Content-Disposition"])), delay(() => {
                        const matchValue_1 = tenant;
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            return singleton(["X-ONE-Tenant", matchValue_1]);
                        }
                    }))));
                })), 0)]);
                const props = (body_1 == null) ? ofArray([new Types_RequestProperties(0, ["GET"]), headers]) : ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [body_1]), headers]);
                return fetch$(addPrefix(tupledArg[0]), props).then((_arg_1) => (Promise.resolve([_arg_1, tupledArg[1]])));
            });
        }));
    }, [(entityImageUrl == null) ? url_7 : ((entityImageUrl_1 = entityImageUrl, concat(url_7, "&entityImageUrl=", ...window.encodeURIComponent(entityImageUrl_1)))), "protocol.pdf", undefined], successMsg, errorMsg);
}

